export enum ECategory {
    new = 'new',
    viewed = 'viewed',
    connected = 'active',
}

export type TResponseDto = {
    stepId: number,
    category: ECategory,
};
